<template>

    <PantalladeCarga v-if="cargando == true" titulo="Cargando..."></PantalladeCarga>


    <div class="container" style="margin-top:30px; margin-bottom:30px;">
        
        <div v-if="title != '' && subtitle != ''" style="padding: 20px; padding-bottom: 0px; text-align: center;">
            <h2 class="h3" v-html="title"></h2>
            <p class="fs-4" v-html="subtitle"></p>
        </div>

        <div v-if="quotation==true && productosMostrados >= 1" style="padding: 20px; padding-right:30px; padding-bottom: 25px; text-align: right;">
            <p class="fs-6" style="padding:0px; margin: 0px; color:#000;"><b>{{$store.state.nombreTomador}}</b></p>
            <p class="fs-6" style="padding:0px; margin: 0px;">Presupuesto Nº {{anio}}/{{idPresupuesto}}/08</p>
            <p class="fs-6" style="padding:0px; margin: 0px;">Nº de Asegurados: <b>{{$store.state.NumeroAsegurados}}</b></p>
            <p class="fs-6" style="padding:0px; margin: 0px;">Forma de Pago: <i>{{periodoCambiar}}</i> <u><strong @click="visualizarFormadePago()" style="cursor:pointer;">[ Cambiar ]</strong></u></p>

        </div>




        <!-- Mensaje No Precio -->

        <div class="row text-center" v-if="quotation==true && productosMostrados == 0" style="padding:10px;">

            <div class="col shadow pl-5 pr-5 custom-bg-soft rounded text-center" style="padding:25px; text-align: center; border: 1px solid #bdbdbd; padding-top:20px;">
                
                
                <img src="/wp-content/themes/tema-algoritmica/assets/img/blocks/errorPresupuesto.png" width="70">

                <p class="text-black" style="font-size:15pt; margin-top:20px;">Upsss!! <br>En estos momentos, no hemos podido ofrecerle precio. <br>Disculpe las molestias. </p>

            </div>
        </div>



        <!-- Selección Periodo de Comparacion -->

        <div class="row text-center" v-if="verFormadePago == true" style="padding:10px;">

            <div class="col shadow pl-5 pr-5 custom-bg-primary rounded text-center" style="padding:15px; text-align: center; border: 1px solid #bdbdbd;">

                <p class="text-white">Seleccione el Fraccionamiento del Pago</p>

                <select class="form-select form-control text-center" id="TipoPago" aria-label="Seleccione el Fraccionamiento del Pago" v-model="periodoCambiar" style="color: #000; font-weight: bold; font-size:10pt; border: 2px solid #bdbdbd;">
                    <template v-for="(Periodo, Tiempo) in PeriodosEscritos" :index="Tiempo">
                        <option v-if="Tiempo == periodoCambiar" :value="Tiempo" selected>{{Tiempo}}</option>
                        <option v-else :value="Tiempo">{{Tiempo}} </option>
                    </template>
                </select>

            </div>
        </div>
           
        <!-- Selección Periodo de Comparacion -->

        <template v-if="(productosElegidos.length >= 2 && filas.length >= 1 && ready == true)">

            <div class="rounded mx-lg-auto mb-7">

            <template v-for="(productosFila, index) of filas" :key="index">

                <Fila
                    :products="productosFila"
                    :quotation="quotation"
                    :idPresupuesto="idPresupuesto"
                    :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
                    :productoAnterior="productoAnterior"
                    @clickProducto="clickProducto"
                    :mostrarInfo="mostrarInfo"
                    
                    v-if="index <= maxFilasShow"
                    >
                    
                </Fila>


            </template>


                <div class="bg-primary-light overflow-hidden" v-if="maxFilasShow < (filas.length-1)">
                    <div class="container position-relative content-space-1 content-space-md-3">
                        <div class="w-lg-65 text-center mx-lg-auto">
                        <div class="mb-7">
                            <h3 class="text-black">¿Quieres ver más productos?</h3>
                        </div>
                        <button style="margin-top:-20px;" class="btn btn-warning btn-lg" @click="masProductos()">✅ Cargar más productos</button>
                        </div>
                    </div>
                </div>


            </div>
        </template>

        
        <template v-if="(productosElegidos.length == 1 && ready == true && numeroColumnasMaximo == 1)">

            <Uniproducto
                :product="productosElegidos[0]"
                :quotation="quotation"
                :idPresupuesto="idPresupuesto"
                :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
                :productoAnterior="productoAnterior"
                @clickProducto="clickProducto"
                >
            </Uniproducto>
    
        </template>

        

        <template v-if="(productosElegidos.length == 1 && ready == true && numeroColumnasMaximo >= 2)">

            <div class="rounded mx-lg-auto mb-7"> 

                <template v-for="(productosFila, index) of filas" :key="index">

                    <Fila
                        :products="productosFila"
                        :quotation="quotation"
                        :idPresupuesto="idPresupuesto"
                        :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
                        :productoAnterior="productoAnterior"
                        @clickProducto="clickProducto"
                        :mostrarInfo="mostrarInfo"
                        
                        v-if="index <= maxFilasShow"
                        >
                        
                    </Fila>


                </template>


            </div>
    
        </template>

    </div>
</template>

<script>


import Fila from './Fila.vue'
import Uniproducto from './UniProducto.vue'
import Prices from '.././MatrixPrices'
import PantalladeCarga from '.././PantalladeCarga.vue'


export default {
  name: 'PricingMultiproducto',
  components : {Fila, Uniproducto, PantalladeCarga},
  props: {
    
    title: String,
    subtitle: String,
    products : Array,
    filter: Array,
    quotation: Boolean,
    UrlDescargaPresupuesto: String,
    productoAnterior: Boolean,
    numeroColumnasMaximo: Number,
    idPresupuesto: String,
    trackingUrlSave: String,
    urlActiveCampaign: String,
    ProductoSeleccionadoEnParrilla: String,
    AddonsSeleccionados: Array,
    PeriodoSeleccionado: String,
    mostrarInfo: Boolean,
    PeriodosEscritos: Object

  },

  data: function () {
              return {
                productosElegidos: [],
                filas: [],
                ready: false,
                maxFilasShow: 0,
                cargando: false,
                anio: 2025,
                verFormadePago: false,
                periodoComparativo: "",
                periodoCambiar: "",
                productosMostrados : 0

              }
  },

  mounted: async function(){


    this.cargando = true;

    await this.filtrarProductos();


    await this.ordernarProductos();

    await this.establecerColumnas();



    this.ready = true;
    this.cargando = false;


    let today = new Date();
    this.anio = today.getFullYear();


    if (this.periodoCambiar == "")
    {
        this.periodoCambiar = this.PeriodoSeleccionado;

    }


    this.$watch('periodoCambiar', async function () {

        await this.resetPeriodoSeleccionado(this.periodoCambiar);

    });

    console.log(this.filas);


  },
  methods: {

    resetPeriodoSeleccionado : async function(periodo){

        await this.$emit("CambiarPeriodoSeleccionado", periodo);


    },

    visualizarFormadePago : async function(){

        this.verFormadePago = true;


    },


    SeleccionarProducto : async function(codigo){

        await this.$store.commit('seleccionarProductoParrilla', codigo);    

    },

    AddonsParrilla : async function(extensiones){

        await this.$store.commit('resetAddonsParrilla', extensiones);

    },


    clickProducto : async function(producto, price, tipo){


        if (this.quotation == true)
        {

            this.cargando = true;

            let addons = [];
            await this.SeleccionarProducto(producto);
            await this.AddonsParrilla(addons);
            //await this.resetPeriodoSeleccionado("Mensual");
            
            await this.$store.commit('ActualizarPrecioFinal', price);

            
            if (this.trackingUrlSave != "")
            {

                let tracking = await Prices.SaveTracking(this.trackingUrlSave, this.idPresupuesto, this.$store.state.PrecioFinal, this.PeriodoSeleccionado, this.AddonsSeleccionados, this.ProductoSeleccionadoEnParrilla);


            }

            if (this.urlActiveCampaign != "")
            {

                let trackingActive = await Prices.SaveTracking(this.urlActiveCampaign, this.idPresupuesto, this.$store.state.PrecioFinal, this.PeriodoSeleccionado, this.AddonsSeleccionados, this.ProductoSeleccionadoEnParrilla);


            }

            this.cargando = false;

        } else {




            
        }



        if (await this.datosProducto(producto))
        {

            let datos = await this.datosProducto(producto);


            if (tipo == "contratar")
            {
            

                if (this.idPresupuesto != null)
                {

                    let url = datos["url"]+"?idPresupuesto="+this.idPresupuesto;
                    window.location.href = url;


                } else {


                    let url = datos["url"];

                    window.location.href = url;

                }



            }

            if (tipo == "info")
            {



                if (this.idPresupuesto != null)
                {

                    let url = datos["link"]+"?idPresupuesto="+this.idPresupuesto;
                    window.location.href = url;


                } else {

                    let url = datos["link"];
                    window.location.href = url;

                }



            }


            if (tipo == "download")
            {

                console.log("Descargando Presupuesto...");


            }



        }





    },

    masProductos : async function(){


       this.maxFilasShow = (this.maxFilasShow+1);



    },



    range : function(start, end){

        if(start === end) return [start];
            return [start, ...this.range(start + 1, end)];

    },


    filtrarProductos: async function(){

        this.productosElegidos = [];

        if (this.filter != null || this.filter.length >= 1)
        {
        
            for (let producto of this.products)
            {


                if (this.filter.includes(producto.name))
                {



                    if (this.quotation)
                    {

                        if (producto.show == true)
                        {

                            this.productosElegidos.push(producto);

                            
                        }
                        
                    } else {

                        this.productosElegidos.push(producto);


                    }




                }


            }

        } else {


            this.productosElegidos = productos;
            

        }



    },

    ordernarProductos: async function(){

        var ProductosOrdenados = [];


        for (let producto of this.productosElegidos)
        {

            if (producto.show == true)
            {

                this.productosMostrados = (this.productosMostrados+1);

            }

            if (this.filter.indexOf(producto.name) >= 0){


                let orden = this.filter.indexOf(producto.name);

                ProductosOrdenados[orden] = producto;

            }


        }


        this.productosElegidos = await this.startFromZero(ProductosOrdenados);

        


    },

    datosProducto: async function(codigo){



        for (let producto of this.productosElegidos)
        {


            if (producto.cod == codigo)
            {

                return producto;

            }

        }



    },

    startFromZero: async function(arr){

        var newArr = [];
        var count = 0;

        for (var i in arr) {
            newArr[count++] = arr[i];
        }

        return newArr;

    },

    establecerColumnas: async function(){


        let numeroProductos = this.productosElegidos.length;




        if (numeroProductos >= this.numeroColumnasMaximo)
        {


            let numeroFilas = Math.ceil(numeroProductos/this.numeroColumnasMaximo);


            let rangofilas = this.range(1, numeroFilas);
            let rangocolumnas = this.range(1, this.numeroColumnasMaximo);


            var indice = 0;


            for (let fila in rangofilas)
            {   

                var filaMatrix = [];


                for (let columna in rangocolumnas)
                {   

                    if (this.productosElegidos[indice])
                    {

                        filaMatrix.push(this.productosElegidos[indice]);
                    
                        indice = (indice+1);

                    }


                }


                this.filas.push(filaMatrix);



            }



        } else {



            this.filas.push(this.productosElegidos);


        }






    }


  }

}
</script>